import React from 'react';
import { Wrapper, Text, Price } from './styled';

const TotalTitle = ({ total, isSideBar, showTotal, title = 'Итого к оплате' }) => (
    <Wrapper isSideBar={isSideBar}>
        <Text isSideBar={isSideBar}>{title} </Text>
        {showTotal && <Price>{total}<span>₽</span></Price>}
    </Wrapper>
);

export default TotalTitle;
